import {
  DELETE_SAMPLE_FAILURE,
  DELETE_SAMPLE_LOADING,
  DELETE_SAMPLE_SUCCESS,
  GET_MODEL_DATA_FAILURE,
  GET_MODEL_DATA_LOADING,
  GET_MODEL_DATA_SUCCESS,
  GET_SAMPLES_DATA_FAILURE,
  GET_SAMPLES_DATA_LOADING,
  GET_SAMPLES_DATA_SUCCESS,
} from '../actions/agentsData';

const defaultState = {
  data: {},
  loading: false,
  error: false,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_MODEL_DATA_LOADING:
    case GET_SAMPLES_DATA_LOADING:
    case DELETE_SAMPLE_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case GET_MODEL_DATA_SUCCESS:
    case GET_SAMPLES_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: { ...state.data, ...action.payload },
      };
    case DELETE_SAMPLE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case GET_MODEL_DATA_FAILURE:
    case GET_SAMPLES_DATA_FAILURE:
    case DELETE_SAMPLE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };
    default:
      return state;
  }
};

export const agentsData = (state) => state.agentsData.agentsData;
export const loadingAgentsDataSelector = (state) => state.agentsData.loading;
export const getAgentData = (state) => state.agentsData.data;
